import React from 'react';
import ProjectAmenities from 'components/organisms/projectAmenities';
import ProjectAmenitiesMobile from 'components/organisms/projectAmenitiesMobile';
import { useViewport } from 'components/templates/viewportProvider';
import { CallToAction } from 'components/atoms/callToAction';

const ProjectAmenitiesViewControl = props => {
  const { isMobile } = useViewport();

  return (
    <div key={'project-amenities'} id={'amenities'}>
      {!isMobile ? (
        <ProjectAmenities props={props} />
      ) : (
        <ProjectAmenitiesMobile props={props} />
      )}
    </div>
  );
};
export default ProjectAmenitiesViewControl;
